import { Page, Tabs } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useAppNavigate } from 'utils/url/useAppNavigate';

type SettingsEmailTab = 'email' | 'identities';
export const SettingsEmailView = (): JSX.Element => {
  const navigate = useAppNavigate();
  const location = useLocation();

  const settingsEmailTabs = useMemo(
    () =>
      [
        { label: 'Email', id: 'email' },
        { label: 'Email identities', id: 'identities' },
      ] satisfies { label: string; id: SettingsEmailTab }[],
    [],
  );

  const handleTabChange = (value: string) => {
    const tab = value as SettingsEmailTab;

    if (tab === 'email') {
      navigate({ path: '/settings/email' });
    } else {
      navigate({ path: `/settings/email/${tab}` });
    }
  };

  const selectedTab = (location.pathname?.split('/').pop() ??
    'email') as SettingsEmailTab;

  return (
    <Page>
      <Page.Head title="Email" />

      <Page.Tabs>
        <Tabs
          tabs={settingsEmailTabs}
          selectedId={selectedTab}
          onChange={handleTabChange}
        />
      </Page.Tabs>

      <Page.Body>
        <Outlet />
      </Page.Body>
    </Page>
  );
};
